import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 1000 1000" {...props}><rect width="100%" height="100%" fill="transparent" /><path d="m0-2198.5 477 479 644-1-2 670 451 453-471 470-9 2267-325 326 234 232 456-454V24.5l625-621-562-561v-896l-878-2-640-642-641 642-877 2v896l-562 561 625 621v2219l455 454 235-232-325-326-10-2267-470-470 450-453-2-670 645 1z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="translate(500.202 422.6)scale(.1551)" /><path d="m2800 4101 385-392-1-527h556l393-379 393 365h508v551l362 384-360 363v554h-552l-351 323-382-323h-565v-550zm745 218v340h350l237 200 217-200 338-2v-341l226-225-224-237v-341h-314l-243-226-246 226h-341v325l-239 252z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="translate(-141.098 -305.801)scale(.1551)" /><path d="M4662 4073c0-300-243-543-543-543s-543 243-543 543 243 543 543 543 543-243 543-543" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="translate(-141.172 -305.87)scale(.1551)" /><path d="m0 1574 303 302 346-342 352 350 894-894-1-2203 463-464-209-207-582 584V918l-565 565-355-355-346 349L0 1174l-300 303-347-349-354 355-565-565v-2218l-583-584-208 207 463 464-2 2203 895 894 351-350 347 342z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="translate(500.228 634.042)scale(.1551)" /><path d="m-271 154.5 294-291-215-216-508 505 538 537 303-302 300 302 259-256-288-287 283-285-554-551-248 249 304 306-381 376z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="translate(478.214 727.945)scale(.1551)" /><path d="m0-219.5-220 221 220 218 220-218z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="translate(595.516 750.223)scale(.1551)" /><path d="M0-310-310 0 0 310 310 0z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="translate(500.034 947.8)scale(.1551)" /></svg>;
export default Component;
export { Component as ReactComponent };